import {Link} from "react-router-dom";
import {useState, useRef} from "react";
import classes from "./header.module.css";
import white_bride from "../../images/white-bride.svg";
import exms from "../../images/Vector.png";
import UserAuth from "../profile/UserAuth";
import ThemeToggle from "../theme/ThemeToggle";

const Header = ({
                    setModalTarget,
                    setLoginModal,
                    isUserAuth,
                    avatar,
                    username,
                    handleLogout,
                }) => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const menuCheckboxRef = useRef(null);
    const handleMenuToggle = () => {
        setIsMenuOpen((prev) => !prev);
    };


    const handleMenuClose = () => {
        setIsMenuOpen(false);
        if (menuCheckboxRef.current) {
            menuCheckboxRef.current.checked = false;
        }
    };


    return (
        <div className={`container ${classes.wrapper}`}>
            <div className={`row`}>
                <div className={`col-8 col-md-8 col-lg-8 col-xxl-6 d-flex ${classes.wrapper_logo}`}>
                    <img src={white_bride} alt="ald"/>
                    <div className={classes.logo_text}>
                        Церковь
                        <br/>
                        “Белая Невеста”
                    </div>

                </div>

                <div
                    className={`d-flex flex-column align-items-end col-4 col-md-4 col-lg-4 col-xxl-6 ${classes.wrapper_navbar}`}>
                    <div className={`d-flex justify-content-center align-items-center`}>
                        <img
                            className={`mb-3  ${classes.text_title} ${classes.ehms}`}
                            src={exms}
                            alt=""
                        />
                        <div className={`text-start`}>
                            <h5 className={`${classes.text_title}`}>Евангельский христианский</h5>
                            <h5 className={`${classes.text_title}`}>миссионерский союз (ЕХМС)</h5>
                        </div>
                        <div className={`${classes.actions}`}>
                            <UserAuth is_user_auth={isUserAuth}
                                      avatar={avatar}
                                      username={username}
                                      onLogout={() => {
                                          handleLogout();
                                          handleMenuClose();
                                      }}
                                      onLogin={() => {
                                          setLoginModal(true);
                                          handleMenuClose();
                                      }}/>
                            <ThemeToggle/>
                        </div>
                    </div>

                    <div className={`d-flex`}>
                        {/* Desktop Menu */}
                        <Link className={`mx-3 ${classes.text_menu}`} to="/">Главная</Link>
                        <Link className={`mx-3 ${classes.text_menu}`} to="/about">О нас</Link>
                        <Link className={`mx-3 ${classes.text_menu}`} to="/preachings">Проповеди</Link>
                        <Link className={`mx-3 ${classes.text_menu}`} to="/events">Мероприятия</Link>
                        <Link className={`mx-3 ${classes.text_menu}`} to="/archive">Архив</Link>

                        <div className={`ms-3 ${classes.connetion_wr}`}>
                            <div className={classes.connetion} onClick={() => setModalTarget(true)}>
                                Связаться
                            </div>
                        </div>


                        {/* Mobile Menu Burger */}
                        <div className={`${classes.menu_phone_but}`}>
                            <input
                                ref={menuCheckboxRef}
                                type="checkbox"
                                onChange={handleMenuToggle}
                                checked={isMenuOpen}
                            />
                            <span></span>
                            <span></span>
                            <span></span>
                            <ul className={`menu ${classes.menu}`}>
                                <li className={classes.menuClose}>
                                    <button type="button" onClick={handleMenuClose} aria-label="Закрыть меню">✕</button>
                                </li>
                                <li>
                                    <Link to="/" onClick={handleMenuClose}>Главная</Link>
                                </li>
                                <li>
                                    <Link to="/about" onClick={handleMenuClose}>О нас</Link>
                                </li>
                                <li>
                                    <Link to="/preachings" onClick={handleMenuClose}>Проповеди</Link>
                                </li>
                                <li>
                                    <Link to="/events" onClick={handleMenuClose}>Мероприятия</Link>
                                </li>
                                <li>
                                    <Link to="/archive" onClick={handleMenuClose}>Архив</Link>
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
            </div>

            <div className={classes.logo_text_phone}>
        <span className={`d-flex justify-content-center align-items-center mt-5 h-100 w-100`}>
          Церковь
          <br/>
          “Белая Невеста”
        </span>
            </div>
        </div>
    );
};

export default Header;
